// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1R_6M","errors":"Errors_errors__3J3Sr"};